export enum V3ProfileHeroColorVariants {
    light = "light",
    dark = "dark"
}